<template>
  <v-container class="mb-9">
    <v-row justify="space-between">
      <h2>
        {{ $t("userguide") }}
      </h2>
    </v-row>
    <v-row :gutter="24" justify="space-around" class="content d-none d-sm-flex">
      <div class="card " v-for="(item,i) in lists" :key="i" @click="goDetail(item)">
        <v-img
            class="white--text align-end mb-8"
            height="72px"
            :src="item.image"
            eager
            contain
        ></v-img>
        <span class="title mb-3">
          {{ item.title }}
        </span>
        <span class="desc ">
          {{ item.blurb }}
        </span>
      </div>
    </v-row>
    <v-row :gutter="24" justify="space-around" class="mt-5 d-flex d-sm-none">
      <v-col cols="6" class="" v-for="(item,i) in lists" :key="i" @click="goDetail(item)">
        <v-img
            class="white--text align-end mb-8"
            height="100px"
            :src="item.image"
            eager
            contain
        ></v-img>
        <v-row no-gutters class="title mb-3">
          {{ item.title }}
        </v-row>
        <v-row no-gutters class="desc">
          {{ item.blurb }}
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'NewsList',

  data: () => ({
    lists: []
  }),
  methods: {
    goDetail(item) {
      this.$router.push({path: '/articaldetail', query: {id: item.id}})
    }
  },
  mounted() {
    this.$api.fetch('/home/getArticleList', {
      "language": this.$i18n.locale,//
      "type": 1,//类型 1手册 2广告 3产品 4活动
      "pageNumber": 1,//当前页
      "pageSize": 10//每页数量
    }).then((res) => {
      console.log(res)
      this.lists = res.list
    }).catch((err) => {
      console.log(err)
    })
  }
}
</script>
<style scoped lang="scss">
.content {
  margin-left: 80px;
  margin-right: 75px;
  margin-top: 40px;
  margin-bottom: 40px;
}

.card {
  width: 380px;
  height: 279px;
  border-radius: 10px;
  padding: 40px 52px 36px 53px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &:hover {
    background: #FFFFFF;
    box-shadow: 0px 30px 80px 0px rgba(0, 0, 0, 0.04);
  }

  .title {
    height: 33px;
    font-family: Poppins, Poppins;
    font-weight: 600;
    font-size: 24px;
    color: #3B3A40;
    line-height: 35px;
    text-align: right;
    font-style: normal;
  }
}
</style>
